import React, {Component} from 'react'

export class InputText extends Component{
    constructor(props){
        super(props)
        this.state = {
            text : this.props.day.comment
        }
        this.onChangeText = (evt) => {
            let newValue = evt.target.value
            this.setState({
                text: newValue
            })
        }
        this.onSaveValue = () => {
            this.props.onSaveCommentDay(this.props.day.date, this.state.text)
        }
    }
    render(){
        return(
            <input
                defaultValue={this.state.text}
                type="text"
                className="form-control"
                onChange={evt => this.onChangeText(evt)}
                onBlur={this.onSaveValue} 
            />
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/CalendarMaintainer/components/InputText.jsx